import { string } from 'prop-types'
import { kuiperClassNames, renderIcon } from '../../utils'

import './styles.scss'

const icon = () =>
  renderIcon('folder-directory', { height: 18, width: 22, ariaMode: 'hidden' })

const ErrorDisplay = ({ error }) => (
  <div className={kuiperClassNames('filebrowser-error-container')}>
    <div className={kuiperClassNames('filebrowser-error')}>
      {icon()}
      <p>{error}</p>
    </div>
  </div>
)

ErrorDisplay.propTypes = {
  error: string,
}

export default ErrorDisplay
